import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'campaign',
                title: 'Campaign',
                translate: 'NAV.CAMPAIGN.TITLE',
                type: 'item',
                icon: 'work_outline',
                url: '/campaigns',
            },
            {
                id: 'database',
                title: 'Database',
                translate: 'NAV.DATABASE.TITLE',
                type: 'item',
                icon: 'list',
                url: '/database',
            },
            {
                id: 'welfare',
                title: 'Welfare',
                translate: 'NAV.WELFARE.TITLE',
                type: 'item',
                icon: 'group',
                url: '/account/welfare',
            },
            {
                id: 'member',
                title: 'Member',
                translate: 'NAV.ACCOUNT.MEMBER.TITLE',
                type: 'item',
                icon: 'group',
                url: '/account/member',
            },
            {
                id: 'activationKey',
                title: 'ActivationKey',
                translate: 'NAV.ACCOUNT.TITLE',
                type: 'item',
                icon: 'group',
                url: '/account/activation',
            },
            {
                id: 'company',
                title: 'Company',
                translate: 'NAV.ACCOUNT.COMPANY.TITLE',
                type: 'item',
                icon: 'business',
                url: 'account/company',
            },
        ],
    },
];
